//@ts-nocheck

'use client'

import React from 'react'
import Image from 'next/image'

import { Heading, Paragraph } from '../../atoms/Typography/Typography.component'
import { Col, Row, SpacerBase } from '../../atoms/GridSystem'
import Button from '../../atoms/Button/Button.component'
import ItemsGrouped from '../../molecules/ItemsGrouped/ItemsGrouped.component'
import Icon from '../../atoms/Icon/Icon.component'

import * as S from './Banner.styles'

interface Modal {
  title: string
  description: string
  ctaPrimary: {
    label: string
    href?: string
  }
  ctaSecondary?: {
    label: string
    href?: string
  }
}

interface BannerImageProps {
  sectionId?: string
  colorScheme?: string
  title?: {
    text: string
    tag?: string
    typo?: string
  }
  subtitle?: {
    text: string
    tag?: string
    typo?: string
  }
  ctaPrimary?: {
    label: string
    href?: string
    variant?: string
  }
  ctaSecondary?: {
    label: string
    href?: string
    variant?: string
  }
  image?: {
    src: string
    alt?: string
    width?: number
    height?: number
  }
  imageShape?: 'circle' | 'leaf' | 'ellipse'
  tabItem?: boolean
  // modalPrimary?: Modal
  // modalSecondary?: Modal
}

const BannerImage = ({
  sectionId,
  colorScheme,
  pretitle,
  title,
  subtitle,
  ctaPrimary,
  ctaSecondary,
  image,
  imageShape,
  tabItem = false,
  // modalPrimary,
  // modalSecondary,
}: BannerImageProps) => {
  const hasImage = image && image.src

  return (
    <S.BannerWrapper sectionId={sectionId} colorScheme={colorScheme}>
      <Row>
        <Col
          xs={12}
          lg={6}
          $order={{ xs: 2, lg: 1 }}
          $direction="column"
        >
          <S.BannerContentWrapper>
            <SpacerBase xs={3} lg={0} />
            <S.BannerIconWrapper>
              <Icon name="leaf-green" useIconColor unlockedProportions />
            </S.BannerIconWrapper>
            {pretitle ? (
              <>
                <SpacerBase xs={1} />
                <Paragraph {...pretitle} />
                <SpacerBase xs={1} />
              </>
            ) : null}
            {title ? (
              <>
                <SpacerBase xs={1.5} lg={0}/>
                <Heading {...title} fontPrimary weight="medium"/>
              </>
            ) : null}
            {subtitle ? (
              <>
                <SpacerBase xs={1.5} />
                <Paragraph {...subtitle} as={'div'} />
              </>
            ) : null}
            {ctaPrimary || ctaSecondary ? (
              <>
                <SpacerBase xs={4} />
                <ItemsGrouped
                  direction={{ xs: "column", xl: "row" }} 
                  space={{ xs: 16, xl: 24 }} 
                  fullWidth={['xs', 'sm', 'md']}
                  justify={{ xs: "center", xl: "flex-start" }}
                > 
                  {ctaPrimary ? (
                    <>
                      <Button
                        {...ctaPrimary}
                        variant="primary"
                        iconEnd="arrow-right"
                      />
                    </>
                  ) : null}
                  {ctaSecondary ? (
                    <>
                      <Button
                        {...ctaSecondary}
                        variant="secondary"
                        iconEnd="arrow-right"
                      />
                    </>
                  ) : null}
                </ItemsGrouped>
              </>
            ) : null}
          </S.BannerContentWrapper>
        </Col>
        {hasImage ? (
          <Col xs={12} lg={6} $order={{ xs: 1, lg: 2 }} $justify={'center'}>
            <S.BannerMaskWrapper maskType={imageShape}>
              <Image
                src={image.src}
                alt={image.alt}
                fill
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 100vw, 100vw"
              />
            </S.BannerMaskWrapper>
          </Col>
        ) : null}
      </Row>
    </S.BannerWrapper>
  )
}

export default BannerImage
